import { render, staticRenderFns } from "./mediapronet.vue?vue&type=template&id=0888774a&scoped=true&"
import script from "./mediapronet.vue?vue&type=script&lang=js&"
export * from "./mediapronet.vue?vue&type=script&lang=js&"
import style0 from "./mediapronet.vue?vue&type=style&index=0&id=0888774a&lang=scss&scoped=true&"
import style1 from "./mediapronet.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888774a",
  null
  
)

export default component.exports